import api from "../../api/shadhin";
import router from "../../router";

const state = {
  error: "",
  statusCode: "",
  errorMsg: "",
  fundingListLoader: false,
  indexData: [],
  investorAgreement: "",
  investeeAgreement: "",
  docImage: "",
  userImage: "",
  test: "",
  fileContent: "",
  shadhinFundingLoanProductId: 0, // 0 = all
  fundingStatusId: 1, // 1 = Pending
  goBackRoute: "#",
  backRouteActive: false,
};
const getters = {
  error: (state) => {
    return state.error;
  },
  statusCode: (state) => {
    return state.statusCode;
  },
  errorMsg: (state) => {
    return state.errorMsg;
  },
  investeeAgreement: (state) => {
    return state.investeeAgreement;
  },
  investorAgreement: (state) => {
    return state.investorAgreement;
  },
  userImage: (state) => {
    return state.userImage;
  },
  docImage: (state) => {
    return state.docImage;
  },
  indexData: (state) => {
    return state.indexData;
  },
  //for testing purpose
  test: (state) => {
    return state.test;
  },
  fileContent: (state) => {
    return state.fileContent;
  },
  shadhinFundingLoanProductId: (state) => {
    return state.shadhinFundingLoanProductId;
  },
  goBackRoute: (state) => state.goBackRoute,
  backRouteActive: (state) => state.backRouteActive,
};

const actions = {
  async indexData({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.fetchAllData(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setData", response);
  },

  async setIndexData({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.fetchData(token, parameters[0]);
    commit("setResponse", response);
  },

  async store({ rootState, commit, dispatch }, parameters) {
    const { token } = rootState.auth;
    const response = await api.storeData(token, parameters[0], parameters[1]);
    commit("setUpdatedResponse", response);
    if (parameters[0] === "loan-purposes") {
      dispatch("setIndexData", ["loan-purposes/all"]);
    }
    // router.push('/task')
  },

  async updateLoanPurpose({ rootState, dispatch }, updateData) {
    // console.log(updateData);
    const { token } = rootState.auth;
    await api.storeData(token, "loan-purposes/" + updateData.id, updateData);
    dispatch("setIndexData", ["loan-purposes/all"]);
  },

  async deleteLoanPurpose({ rootState, dispatch }, id) {
    const { token } = rootState.auth;
    await api.deleteData(token, "loan-purposes", id);
    dispatch("setIndexData", ["loan-purposes/all"]);
  },

  async update({ rootState, commit }, updateData) {
    const { token } = rootState.auth;
    const response = await api.updateData(
      token,
      updateData.id,
      updateData,
      "task"
    );
    commit("setData", response);
    router.push("/task");
  },
  async delete({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.deleteData(token, parameters[0], parameters[1]);
    commit("setResponse", response);
  },
  async getFundingList({ state, rootState, commit }, parameters) {
    commit("setFundingListLoader");
    commit("resetAllData");
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      state.shadhinFundingLoanProductId,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
    commit("setFundingListLoader");
  },
  async getFundingListLoanProduct({ rootState, commit }, parameters) {
    commit("setFundingListLoader");
    commit("resetAllData");
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5]
    );
    commit("setData", response);
    commit("setFundingListLoader");
  },
  async changeStatus({ state, rootState, commit }, parameters) {
    commit("setFundingListLoader");
    commit("resetAllData");

    const { token } = rootState.auth;
    await api.changeDataStatus(
      token,
      null,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3],
      parameters[4],
      parameters[5]
    );
    // commit("resetShadhinFundingLoanProductId");
    const response = await api.changeDataStatus(
      token,
      state.shadhinFundingLoanProductId,
      "funding-list",
      state.fundingStatusId,
      parameters[2],
      parameters[3],
      parameters[4]
    );
    commit("setData", response);
    commit("setFundingListLoader");
  },

  async searchByDisbursedUser({ rootState, commit }, payload) {
    commit("resetAllData");

    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      0,
      "funding-list",
      8,
      payload, // Phone no.
      1,
      1
    );
    commit("setData", response);
  },

  async pendingStatusData({ rootState, commit }) {
    const { token } = rootState.auth;
    const response = await api.changeDataStatus(
      token,
      "funding-list",
      1,
      "",
      1,
      5
    );
    commit("setData", response);
  },
  async changeInvestorAdjuStatus({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.changeInvestorDataStatus(
      token,
      parameters[0],
      parameters[1]
    );
    commit("setInvestorPending", response);
  },
  async getPaginatedIndexData({ rootState, commit }, parameters) {
    const { token } = rootState.auth;
    const response = await api.getIndexDataByPagination(
      token,
      parameters[0],
      parameters[1],
      parameters[2],
      parameters[3]
    );
    commit("setResponse", response);
  },

  async downloadFile({ rootState, commit }, url) {
    const { token } = rootState.auth;
    const response = await api.downloadFile(token, url);
    commit("setFileContent", response);
  },

  setErrorZero({ commit }) {
    commit("setErrorToZero");
  },

  resetAll({ commit }) {
    commit("resetAllData");
  },
};

const mutations = {
  // change shadhin funding loan product for filtering
  setLoanProductId: (state, payload) => {
    state.shadhinFundingLoanProductId = payload;
  },
  setFundingStatusId: (state, payload) => {
    state.fundingStatusId = payload;
  },
  setData: (state, responseData) => {
    // state.test = responseData
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = "No data available";
      state.indexData = responseData.data.data.pendingDetails;
      state.investorAgreement = responseData.data.data.investorAgreement;
      state.investeeAgreement = responseData.data.data.investeeAgreement;
      state.userImage = responseData.data.data.userImage;
      state.docImage = responseData.data.data.docImage;
    }
  },
  setResponse: (state, responseData) => {
    // state.test = responseData
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
      state.indexData = responseData.data.data;
    }
  },
  setUpdatedResponse: (state, responseData) => {
    // state.test = responseData
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
    }
  },

  setInvestorPending: (state, responseData) => {
    // state.test = responseData
    if (responseData.data.error == 1) {
      state.statusCode = responseData.data.statusCode;
      state.error = responseData.data.error;
      state.errorMsg = responseData.data.errorMsg;
    } else {
      state.error = responseData.data.error;
      state.statusCode = responseData.data.statusCode;
      state.errorMsg = responseData.data.errorMsg;
      state.indexData = responseData.data.data.investorApplications;
    }
  },
  setFileContent: (state, responseData) => {
    // state.test = responseData
    state.fileContent = responseData;
  },

  setErrorToZero: (state) => {
    state.error = 0;
  },

  setTest: (state, responseData) => {
    state.test = responseData.data;
    // state.test = credentials[0] + '/' + credentials[1] + '/' + credentials[2] + '/' + credentials[3]
  },

  setFundingListLoader: (state) => {
    state.fundingListLoader = !state.fundingListLoader;
  },

  setGoBackRoute(state, goBackRoute) {
    state.backRouteActive = true;
    state.goBackRoute = goBackRoute;
  },

  resetBackPageActive(state) {
    state.backRouteActive = false;
  },

  resetShadhinFundingLoanProductId: (state) => {
    state.shadhinFundingLoanProductId = 0;
  },

  resetAllData: (state) => {
    state.error = "";
    state.statusCode = "";
    state.errorMsg = "";
    state.indexData = [];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
